import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, of, Observable } from 'rxjs';
import { catchError, expand, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { TimeSeriesAggrMethods, TimeSeriesAggrPeriod } from '../model/time-series-query';
import { TimeSeries, TimeSeriesSingleAttribute } from '../model/timeSeries';
import { UrlConfig } from '../model/urlconfig';

let quantumLeapBaseUrl = `${environment.timeSeriesDbUrl}/v2/entities`;
const attributePath = 'attrs';

@Injectable({
  providedIn: 'root'
})
export class TimeSeriesHistoryService implements UrlConfig {


  constructor(private http: HttpClient) {

  }
  updateEntitiesUrl(qlTimeSeriesBaseUrl: string): void {
    quantumLeapBaseUrl = `${qlTimeSeriesBaseUrl}/v2/entities`;
  }

  getLastNValues(
    type: string,
    entityId: string | number,
    lastN: number,
    attribute: string,
    fromDate?: string,
    toDate?: string
  ) {

    const emptyTimeSeriesSingleAttribute: TimeSeriesSingleAttribute = {
      entityId: entityId.toString(),
      index: [],
      attrName: attribute,
      values: []
    };
    const urlWithOptions = this.getLastNOptions(type, entityId, attribute, fromDate, toDate);
    return this.http.get<TimeSeriesSingleAttribute>(urlWithOptions.url, urlWithOptions.options).pipe(
      catchError(() => of(emptyTimeSeriesSingleAttribute)),
    );
  }

  getLastNValuesForAllAttributes(
    type: string,
    entityId: string | number,
    lastN: number,
    fromDate?: string,
    toDate?: string) {


    const emptyTimeSeries: TimeSeries = {
      entityId: entityId.toString(),
      attributes: [],
      index: []
    };
    const urlWithOptions = this.getLastNOptions(type, entityId, null, fromDate, toDate);

    let offset = 0;
    let limit = 10000;
    return this.http.get<TimeSeries>(urlWithOptions.url, urlWithOptions.options).pipe(
      catchError(() => of(emptyTimeSeries)),
      expand(data => data.index.length > 0 && data.index.length === 10000 ?
        this.getNextXTSItems(entityId, urlWithOptions.url, offset += limit + 1, limit += limit, urlWithOptions.options) : EMPTY));
  }

  private getNextXTSItems(entityId, url: string, offset: number, limit: number, options: HttpOptions): Observable<TimeSeries> {

    const paginationOptions = options;
    paginationOptions.params = {
      ...options.params,
      offset: offset.toString(),
      limit: limit.toString()
    };

    const emptyTimeSeries: TimeSeries = {
      entityId: entityId.toString(),
      attributes: [],
      index: []
    };
    return this.http.get<TimeSeries>(url, paginationOptions).pipe(catchError(() => of(emptyTimeSeries)));
  }


  private getLastNOptions(
    type: string,
    entityId: string | number,
    attribute?: string,
    fromDate?: string,
    toDate?: string) {
    let url = `${quantumLeapBaseUrl}/${entityId}`;
    const options: HttpOptions = {
      headers: {
        'fiware-service': 'inspire',
        'fiware-servicepath': '/',
      },
      params: {
        type,
      },
    };
    if (fromDate) {
      options.params = { ...options.params, ...{ fromDate } };
    }

    if (toDate) {
      options.params = { ...options.params, ...{ toDate } };
    }

    options.params = { ...options.params, ...{ limit: 10000 } };

    if (attribute) {
      url += `/${attributePath}/${attribute}`;
    }
    return {
      url,
      options
    };
  }

  getAggregatedData(
    type: string,
    attribute: string,
    entityId: string | number,
    aggrMethod: TimeSeriesAggrMethods,
    aggrPeriod: TimeSeriesAggrPeriod,
    fromDate?: string,
    toDate?: string
  ) {
    const url = `${quantumLeapBaseUrl}/${entityId}/${attributePath}/${attribute}`;
    const options: HttpOptions = {
      headers: {
        'fiware-service': 'inspire',
        'fiware-servicepath': '/',
      },
      params: {
        type,
        aggrMethod,
        aggrPeriod
      },
    };

    if (fromDate) {
      options.params = { ...options.params, ...{ fromDate } };
    }

    if (toDate) {
      options.params = { ...options.params, ...{ toDate } };
    }
    const emptyTimeSeriesSingleAttribute: TimeSeriesSingleAttribute = {
      entityId: entityId.toString(),
      index: [],
      attrName: attribute,
      values: []
    };
    return this.http.get<TimeSeriesSingleAttribute>(url, options).pipe(
      catchError(() => of(emptyTimeSeriesSingleAttribute)));
  }




}
export interface HttpOptions {
  headers?: HttpHeaders | {
    [header: string]: string | string[];
  };
  params?: HttpParams | {
    [param: string]: any | any[];
  };
}
